import React, { useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../common/Config";

const BatchWiseStockDetailsReport = () => {
    const { id } = useParams(); // product_id from URL
    const accessToken = localStorage.getItem('accessToken');
    const batchReportRef = useRef(null);

    // Add state for product name
    const [productName, setProductName] = React.useState('');

    const fetchBatchReport = () => {
        const $table = $(batchReportRef.current);

        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }

        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.API_URL}/getProductBatchReport/${id}`,
                type: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                dataSrc: function (json) {
                    // Set totals from API response
                    $('#totalRemainingBoxes').html(parseFloat(json.total_remaining_boxes || 0).toFixed(0));
                    $('#totalRemainingPieces').html(parseFloat(json.total_remaining_pieces || 0).toFixed(0));
                    // Set product name if present in API response
                    if (json.product_name) {
                        setProductName(json.product_name);
                    } else if (json.batches && json.batches.length > 0 && json.batches[0].product_name) {
                        setProductName(json.batches[0].product_name);
                    }
                    // Return batches array for DataTable
                    return json.batches || [];
                }
            },
            columns: [
                { data: null, title: 'Sr. No.', orderable: false, width: '10px !important' },
                { data: 'batch_no', title: 'Batch No' },
                { 
                    data: 'expiry_date', 
                    title: 'Expiry Date', 
                    render: data => {
                        if (!data) return '-';
                        const d = new Date(data);
                        const day = String(d.getDate()).padStart(2, '0');
                        const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-based
                        const year = d.getFullYear();
                        return `${day}-${month}-${year}`;
                    }
                    },
                { data: 'cost_price', title: 'Cost Price', render: data => parseFloat(data || 0).toFixed(2) },
                { data: 'sell_price', title: 'Sale Price', render: data => parseFloat(data || 0).toFixed(2) },
                { data: 'total_sales_boxes', title: 'Total Sale Box', render: data => parseFloat(data || 0).toFixed(2) },
                { data: 'total_sales_pieces', title: 'Total Sale Pic', render: data => parseFloat(data || 0).toFixed(2) },
                { data: 'profit_loss', title: 'Profit/Loss', render: data => parseFloat(data || 0).toFixed(2) },
                
                { data: 'original_boxes', title: 'Purchase Box', render: data => data !== null ? data : '0' },
                { data: 'original_pieces', title: 'Purchase Pic', render: data => data !== null ? data : '0' },
                { data: 'sold_boxes', title: 'Sold Box', render: data => data !== null ? data : '0' },
                { data: 'sold_pieces', title: 'Sold Pic', render: data => data !== null ? data : '0' },
                { data: 'remaining_boxes', title: 'Rem. Box', render: data => data !== null ? data : '0' },
                { data: 'remaining_pieces', title: 'Rem. Pic', render: data => data !== null ? data : '0' }
            ],
            columnDefs: [
                {
                    targets: 0,
                    className: 'text-center',
                    createdCell: function (td, cellData, rowData, row) {
                        $(td).html(row + 1);
                    }
                }
            ],
            pageLength: 25,
        });
    };

    useEffect(() => {
        fetchBatchReport();
    }, [id]);

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports/inventory_sales_report">Reports</Link>
                            <Link to="/reports/batch_stock_report">Batch Stock Report</Link>
                            <span>Product Batch Report</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-container">
                <div className="container-fluid">
                    {/* Show product name if available */}
                    {productName && (
                        <div className="row" style={{ backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '2px', marginBottom: '-55px' }}>
                            <div className="col-12">
                                <h5>Product: {productName}</h5>
                            </div>
                        </div>
                    )}
                    <div className="dashboard mt-4">
                        <div className="verical-scrl-wrapper common-table autoheight-table batchwisereport" id="style-3">
                            <div className="table-responsive">
                                <table ref={batchReportRef} className="table table-bordered resizable" style={{ minWidth: '1000px' }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Batch No</th>
                                            <th>Expiry Date</th>
                                            <th>Cost Price</th>
                                            <th>Sale Price</th>
                                            <th>Purchased Qty</th>
                                            <th>Sold Qty</th>
                                            <th>Remaining Qty</th>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="12" className="text-end">Total:</th>
                                            <th id="totalRemainingBoxes">0</th>
                                            <th id="totalRemainingPieces">0</th>
                                        </tr>
                                    </tfoot>
                                    <tbody></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BatchWiseStockDetailsReport;
